import React from 'react';
import { SnackbarProvider, SnackbarProviderProps } from 'notistack';
import { makeStyles } from '~/UIKit/Style';
import {
  CHIP_COLOR_GREEN,
  CHIP_COLOR_ORANGE,
  CHIP_COLOR_RED,
  PRIMARY_BLUE,
} from '../../Constants/Colors.constants';
import { Checkmark } from '../Icons/Checkmark';
import { FONT_SIZE_INBETWEEN } from '~/Constants/UI.constants';
import { AlertTriangleBold } from '../Icons';

// Sadly colors need to be important since library uses that to inject
// it's own color...duh
const useSnackbarStyles = makeStyles({
  containerRoot: {
    padding: '0 !important',
    '& > div > div': {
      padding: '0 !important',
    },
  },
  root: {
    fontSize: `${FONT_SIZE_INBETWEEN} !important`,
    borderRadius: '4px !important',
    lineHeight: '22px !important',
    wordBreak: 'break-word !important',
    '& > div': {
      display: 'grid !important',
      gridTemplateColumns: '1fr max-content !important',
      padding: '16px !important',
    },
    '& > div > div:first-of-type': {
      padding: '0 !important',
      alignItems: 'start !important',
      display: 'flex !important',
      columnGap: '16px !important',
    },
    '& > div > div:last-of-type': {
      padding: '0 !important',
      alignSelf: 'start !important',
    },
  },
  error: {
    backgroundColor: `${CHIP_COLOR_RED} !important`,
  },
  success: {
    background: `${CHIP_COLOR_GREEN} !important`,
    marginBottom: '40px !important',
  },
  warning: {
    backgroundColor: `${CHIP_COLOR_ORANGE} !important`,
  },
  info: {
    backgroundColor: `${PRIMARY_BLUE} !important`,
  },
});

const NeoSnackbarProvider = ({ maxSnack, children }: SnackbarProviderProps) => {
  const { classes } = useSnackbarStyles();

  return (
    <SnackbarProvider
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      classes={{
        root: classes.root,
        containerRoot: classes.containerRoot,
        variantError: classes.error,
        variantInfo: classes.info,
        variantSuccess: classes.success,
        variantWarning: classes.warning,
      }}
      iconVariant={{
        success: <Checkmark />,
        warning: <AlertTriangleBold />,
      }}
      maxSnack={maxSnack}
    >
      {children}
    </SnackbarProvider>
  );
};

export default NeoSnackbarProvider;
